import { TransactionEntity } from '../entities/transaction-entity';

export default class State {
  loaded = false;

  items: Array<TransactionEntity> = [];
}
